import React from "react";
import { SwarovskiOptikFormInputElementParams } from "./types";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../../../../styles/styles-css-variables";
import { fontColor, FONTS, fontSize } from "../../../../../../styles/fonts";

export const InputInput: React.FC<SwarovskiOptikFormInputElementParams> = props => {
  const required = props.element.required === "yes-but-without-native-validation" ? false : props.element.required;

  return (
    <input
      className={props.className}
      name={props.name}
      disabled={props.element.disabled}
      required={required}
      css={textFieldInputStyles}
      type={props.element.type || "text"}
      value={props.value}
      autoComplete={props.element.autoComplete}
      onChange={e => {
        const { value } = e.target;

        let wasAutofilled = false;
        try {
          wasAutofilled = e.target.matches(":-internal-autofill-selected");
        } catch {
          // ignore the error - this is a webkit specific selector
          // that fails on other browsersgs
        }

        props.onChange(value, wasAutofilled);
      }}
      onBlur={props.onBlur}
      onPaste={props.onPaste}
      onKeyDown={
        props.onKeyDown
          ? e => {
              props.onKeyDown!(e.key);
            }
          : undefined
      }
      minLength={props.element.minLength}
      maxLength={props.element.maxLength}
    />
  );
};

export const textFieldInputStyles = [
  FONTS.SwarovskiFutura300,
  fontColor.black,
  fontSize.x2,
  css`
    width: 100%;
    border: 1px solid var(--border-color, ${CSS_COLORS.Green});
    border-radius: 8px;

    height: 40px;

    display: flex;
    justify-content: center;

    padding: 0 12px;

    background-color: var(--bg-color);
    color: var(--text-color);

    &:focus {
      outline: 1px solid var(--border-color, ${CSS_COLORS.Green}) !important;
    }

    --disabled-color: ${CSS_COLORS.Grey3};

    .variant-outline & {
      --disabled-color: ${CSS_COLORS.Grey0};
    }

    &:-webkit-autofill,
    &:-webkit-autofill:focus {
      transition:
        background-color 0s 600000s,
        color 0s 600000s !important;
    }

    &[disabled] {
      color: ${CSS_COLORS.Grey3};
      border-style: dotted;
      cursor: not-allowed;
    }
  `,
];
